module.exports = __webpack_public_path__ + "static/backmin-565aaba854e18186decd9526e9e9292e.jpg";